import React from "react";

function Hero() {
  return (
    <div className="container">
      <div className="row border-bottom p-5 mt-3 text-center">
        <h1>Pricing</h1>
        <h3 className="text-muted fs-5 mt-3 ">
          Free equity investment and flat ₹20 intraday and F&O trades
        </h3>
      </div>

      <div className="row p-5 mt-5">
        <div className="col-4 p-5">
          <img src="media/images/pricingEquity.svg" style={{ width: "80%" }} />
          <h1 className="fs-4 text-muted">Free equity delivery</h1>
          <p className="text-muted">
            All equity delivery investments (NSE, BSE), are absolutely free — ₹
            0 brokerage.
          </p>
        </div>

        <div className="col-4 p-5">
          <img src="media/images/intradayTrades.svg" style={{ width: "80%" }} />
          <h1 className="fs-4 text-muted">Intraday and F&O trades</h1>
          <p className="text-muted">
            Flat ₹ 20 or 0.03% (whichever is lower) per executed order on
            intraday trades across equity, currency, and commodity trades. Flat
            ₹20 on all option trades.
          </p>
        </div>

        <div className="col-4 p-5">
          <img src="media/images/pricingEquity.svg" style={{ width: "80%" }} />
          <h1 className="fs-4 text-muted">Free direct MF</h1>
          <p className="text-muted">
            All direct mutual fund investments are absolutely free — ₹ 0
            commissions & DP charges.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hero;
